export const css = {
	oneaction: '_1tSRv2Ww',
	' _key': 'afcpe-theme/afcpe/quiz-widgets/pretest-review'
};

export default css;
